import { render, staticRenderFns } from "./StatusReadDocuments.vue?vue&type=template&id=256cf268&scoped=true"
import script from "./StatusReadDocuments.vue?vue&type=script&lang=js"
export * from "./StatusReadDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256cf268",
  null
  
)

export default component.exports